import React,{Component} from 'react';
import './PBPage.css';

import { logo, productionBaselineBanner } from '../../_utils/images';
import Page from '@acri-tools/react-tools/components/Page/Page';
import routes from '../../_utils/routes';
import Footer from '../../components/Footer/Footer';
import Search from '@acri-tools/react-tools/components/Search/Search';
import { API_URL } from '../../_utils/config';
import request from '@acri-tools/react-tools/utils/request';
import { searchParamsQuery } from '@acri-tools/react-tools/utils/query';
import { axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import classNames from 'classnames';

interface Props{
}
interface State{
    count: number
    searchParams: any
    entities?: Array<any>
    filters: any
    filterEnabled: boolean

    loading?: boolean
}

export default class PBPage extends Component<Props, State> {
    constructor(props:Props){
        super(props);
        this.state = {
            count: 0,
            searchParams:{
                search: '',
                offset: '0',
                limit: '10',
    
                orderby: 'production_chain',
                orderbyDirection: 'asc',
            },
            filters:{
                "production_chain": { active:true },
                "processing_chain": { active:true },
                "timeliness": { active:true },
                "mode": { active:true },
                "baseline": { active:true },
                "IPF": { active:true },
                "IPF_version": { active:true },
            },
            filterEnabled: false,
        }
    }

    componentDidMount(){
        this.search()
    }

    render(){
        return (
        <Page 
            id="pb"
            title="Production Baseline"
            footer={<Footer/>}
            banner={{
                bannerImage: productionBaselineBanner,
                topBar:{
                    routes: routes,
                    logo: logo,
                }
            }}
        >
            <div className="page-content">
                <div className="centered-content padding">
                    <Search 
                        orderby={[
                            "production_chain",
                            "processing_chain",
                            "timeliness",
                            "mode",
                            "baseline",
                            "IPF",
                            "IPF_version",
                        ]} 
                        count={this.state.count}
                        filters={this.state.filters} searchParams={this.state.searchParams} search={this.search} >
                        <div className="results">
                            <div className="results-table">
                                <table className="table-kpi">
                                    <thead>
                                        <tr>
                                            <th>Production chain</th>
                                            <th>Processing chain</th>
                                            <th>Timeliness</th>
                                            <th>Mode</th>
                                            <th>Baseline</th>
                                            <th>IPF</th>
                                            <th>IPF version</th>
                                            <th>Static ADFs</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.entities &&
                                            this.state.entities.map(( entity:any, idx:number )=>(
                                                <>
                                                    <tr key={idx} style={{ height: 30}}>
                                                        <td>{entity.production_chain}</td>
                                                        <td>{entity.processing_chain}</td>
                                                        <td>{entity.timeliness}</td>
                                                        <td>{entity.mode}</td>
                                                        <td>{entity.baseline}</td>
                                                        <td>{entity.IPF}</td>
                                                        <td>{entity.IPF_version}</td>
                                                        <td width={100}>
                                                            {
                                                                entity.products &&
                                                                <div className="pc-products">
                                                                    <div className="pc-product-count">
                                                                        { entity.products?.length }
                                                                    </div>
                                                                    <div className={classNames({
                                                                            "toggle-products tt": true,
                                                                            "toggled": entity.opened
                                                                        })}
                                                                        onClick={()=>{
                                                                            entity.opened = !entity.opened;
                                                                            this.forceUpdate();
                                                                        }} 
                                                                    >
                                                                        <i className="fas fa-chevron-left"/>
                                                                        <div className="tt-tooltip">
                                                                            show Static ADFs
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </td>
                                                    </tr>
                                                    {
                                                        entity.opened &&
                                                        <tr>
                                                            <td colSpan={8}>
                                                                <div className="pb-products-title">
                                                                    Static ADFs 
                                                                    <span className="product-count">{ entity.products?.length }</span>
                                                                </div>
                                                                <div className="pb-products scrollbar">
                                                                    <ol>
                                                                    {
                                                                        entity.products?.map((product: string)=>(
                                                                            <li className="pb-product">
                                                                                { product }
                                                                            </li>
                                                                            // <div className="pb-product">
                                                                            //     { product }
                                                                            // </div>
                                                                        ))
                                                                    }
                                                                    </ol>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    }
                                                </>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Search>
                </div>
            </div>
        </Page>
        );
    }
    



    search = async() =>{
        this.setState({ loading:true });
        try{
            let res = await request(`${API_URL}/api/v1/production_baselines`,{
                method:'get',
                params:{
                    ...searchParamsQuery(this.state.searchParams, this.state.filters),
                    count: true
                },
            })
            this.setState({ entities: res.data.value, count: res.data.count });
        }
        catch(e){
            axiosErrorHandler( e, { 
                functionName: 'search', 
                requestName: 'search_production_baselines',
            })
            // this.setState({
            //     message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
            //     messageType: 'error'
            // })
        }
        finally{
            this.setState({ loading:false })
        }
    }


};